import BlogPage from '../../../js/pages/BlogPage';

import {getPosts} from '../../../../server/services/blog';

export default BlogPage;

export async function getStaticProps({params}) {
  const posts = await getPosts({tag: params.tag});

  const tag = posts?.[0]?.tags?.find(({slug}) => slug === params.tag);

  if (!tag) {
    return {notFound: true};
  }

  return {
    props: {posts, tag},
    revalidate: 60,
  };
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking',
  };
}
